/**
 * Status cell of « Mes contrats »: the raw `lib_situation` as a dotted
 * `StatusBadge` (green « En cours » / red « Résilié ») wrapped in its
 * tooltip. `null` ⇒ empty cell. Rendered through the DataList custom
 * renderer `CONTRACT_STATUS_RENDERER` (desktop rows and mobile cards).
 */

import { Tooltip } from '@components/base/display';

import { StatusBadge } from '../shared/StatusBadge';
import { CONTRACT_STATUS_BADGE, contractStatusTooltip } from './contractStatus';

export function ContractStatusCell({ value }: Readonly<{ value: unknown }>) {
  const raw = typeof value === 'string' || typeof value === 'number' ? value : null;
  const badge = <StatusBadge value={raw} config={CONTRACT_STATUS_BADGE} />;
  const tooltip = contractStatusTooltip(raw);
  if (tooltip === undefined) return badge;
  return (
    <Tooltip content={tooltip}>
      <span className="inline-flex" data-testid="contract-status">
        {badge}
      </span>
    </Tooltip>
  );
}
